module.exports = __webpack_public_path__ + "img/antigua-and-barbuda.b58f7f0a.png";